'use strict';

module.exports = function () {
    var modal = $('#companyMissingInfoModal');
    modal.find('a.cc-btn--primary').on('click', function () {
        var profileUrl = new URL(this.href, window.location.origin);
        profileUrl.searchParams.set('returnUrl', window.location.pathname + window.location.search + window.location.hash);
        this.href = profileUrl.toString();
    });
    if (modal.length && typeof modal.modal === 'function') {
        modal.appendTo('body').modal('show');
    }

    $(modal).on('click', function (e) {
        if (e.target === this) {
            $(modal).modal('hide');
        }
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            $(modal).modal('hide');
        }
    });
};